const CardTags = ({ tags }) => {
  return (
    <div className="card__tags">
      <h3>Tags:</h3>
      <p>{tags}</p>
    </div>
  );
};

export default CardTags;
